import {createRouter, createWebHistory} from 'vue-router'
import {useStore} from "@/stores/store";

const routes = [
    {
        path: '/',
        name: 'anasayfa',
        component: () => import('@/views/AnasayfaView.vue')
    },
    {
        path: '/IsTakvimi/:id?',
        name: 'IsTakvimi',
        component: () => import('@/views/IsTakvimiView.vue')
    },
    {
        path: '/Birimler',
        name: 'Birimler',
        component: () => import('@/views/BirimlerView.vue'),
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router
